import styled from "styled-components";

export const AllTransactionListWrapper = styled.div`
    position: absolute;
    top: 40px;
    width: 96%;
`